import React from "react";
import { formatContext } from "../../utils/assignments/formatContext";
import "../../styles/questionColumn.css";

const AnswerChoice = ({
  label,
  text,
  selected,
  onClick,
  disabled,
  isCorrectSelected = false,
  isIncorrectSelected = false,
  isCorrectChoice = false,
}) => {
  const className = [
    "answer-choice",
    selected ? "selected" : "",
    disabled ? "disabled" : "",
    isCorrectSelected ? "correct-selected" : "",
    isIncorrectSelected ? "incorrect-selected" : "",
    isCorrectChoice ? "correct-choice" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={className}
      onClick={disabled ? undefined : onClick}
      style={{ cursor: disabled ? "default" : "pointer" }}
    >
      <div className="choice-letter">{label}</div>

      <div className="choice-text">{text ? formatContext(text) : null}</div>

      {/* Right-side tags */}
      {isCorrectSelected && (
        <div className="choice-tag choice-tag-your-pick">Your pick</div>
      )}

      {isCorrectChoice && !selected && (
        <div className="choice-tag choice-tag-correct">Correct</div>
      )}

      {isIncorrectSelected && (
        <div className="choice-tag choice-tag-wrong">Your pick</div>
      )}
    </div>
  );
};

export default AnswerChoice;
